'use client';

import { __styles, mergeClasses } from '@griffel/react';
export const navSubItemGroupClassNames = {
  root: 'fui-NavSubItemGroup'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    Bnnss6s: "fi64zpg",
    Bz10aip: "f1yj8dow",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1a3p1vp"
  }
}, {
  d: [".fi64zpg{flex-shrink:0;}", ".f1yj8dow{transform:translateZ(0);}", [".f1a3p1vp{overflow:hidden;}", {
    p: -1
  }]]
});
/**
 * Apply styling to the NavSubItemGroup slots based on the state
 */
export const useNavSubItemGroupStyles_unstable = state => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(navSubItemGroupClassNames.root, styles.root, state.root.className);
  return state;
};